import { format } from 'owa-string-utils';
import { getLocalizedString } from '../localization/getLocalizedString';
import differenceInDays from '../owaDate/differenceInDays';
import differenceInHours from '../owaDate/differenceInHours';
import differenceInMinutes from '../owaDate/differenceInMinutes';
import isAfter from '../owaDate/isAfter';
import { OwaDate } from '../schema';
import formatUserDate from './formatUserDate';

const MAX_MINUTES_AGO = 59;
const MAX_HOURS_AGO = 23;
const MAX_DAYS_AGO = 30;

export default function formatPastRelativeDateTime(
    pastDateTime: OwaDate,
    compareToDateTime: OwaDate
): string {
    if (isAfter(pastDateTime, compareToDateTime)) {
        // Default to one minute ago in that case
        // as this is corner scenario
        const oneMinuteAgoText = getLocalizedString('oneMinuteAgoText');
        return oneMinuteAgoText;
    }

    const diffMins = differenceInMinutes(compareToDateTime, pastDateTime);
    if (diffMins <= MAX_MINUTES_AGO) {
        const oneMinuteAgoText = getLocalizedString('oneMinuteAgoText');
        const minutesAgoText = getLocalizedString('minutesAgoText');

        return diffMins > 1 ? format(minutesAgoText, diffMins) : oneMinuteAgoText;
    }

    const diffHours = differenceInHours(compareToDateTime, pastDateTime);
    if (diffHours <= MAX_HOURS_AGO) {
        const oneHourAgoText = getLocalizedString('oneHourAgoText');
        const hoursAgoText = getLocalizedString('hoursAgoText');

        return diffHours > 1 ? format(hoursAgoText, diffHours) : oneHourAgoText;
    }

    const diffDays = differenceInDays(compareToDateTime, pastDateTime);
    if (diffDays <= MAX_DAYS_AGO) {
        const oneDayAgoText = getLocalizedString('oneDayAgoText');
        const daysAgoText = getLocalizedString('daysAgoText');
        return diffDays > 1 ? format(daysAgoText, diffDays) : oneDayAgoText;
    }

    return formatUserDate(pastDateTime);
}
